
pingSide=false;


//
function round(wert, dez) {
    wert = parseFloat(wert);
    if (!wert) return 0;
    dez = parseInt(dez);
    if (!dez) dez=0;

    var umrechnungsfaktor = Math.pow(10,dez);

    return Math.round(wert * umrechnungsfaktor) / umrechnungsfaktor;
}



function bootstrapSize() {
    var fontfamily = $('html').css('font-family');

    console.log(fontfamily);

    return fontfamily;
}


// ----------------------------------------------------------------------------------
// Krumme Bildgrößen reparieren!!!!
// ----------------------------------------------------------------------------------
function fixGallery() {

    var portraitHeight=$('.image.index-2').height();
    var squareHeight= $('.image.index-0').height();
    var contentHeight=$('.gallery.squares-portrait .content');

    var gallery

    var contentHeightFixed=(portraitHeight-20)-squareHeight+10;

    if (contentHeight < portraitHeight) {
        $('.gallery.squares-portrait .content').css('height', contentHeightFixed + 'px');
    }

}


// ----------------------------------------------------------------------------------
// Splashscreen Abspielbereitff
// ----------------------------------------------------------------------------------
function playSplashVideo() {


    setTimeout(function () {
        console.log('Splash startet');

        video = $('.splashscreen video')[0];
        $('.loading').fadeOut(500);
        $('.splashscreen video').fadeIn(500);
        video.play();

        $('.splashscreen .sound').fadeIn(500);

    }, 1000);
}


// ----------------------------------------------------------------------------------
// Smoother scroll
// ----------------------------------------------------------------------------------

function scrollToTarget(target) {

    //console.log('Scrolle an eine Stelle'+target.attr('class'));

    if (target.length) {
        $('html, body').animate({
            scrollTop: (target.offset().top - 280)
        }, 1000,function () {

        });
        return false;
    }
}


// ----------------------------------------------------------------------------------
// Entfernt den Hash in der Url TEST
// ----------------------------------------------------------------------------------
function removeHash () {
    history.pushState("", document.title, window.location.pathname
        + window.location.search);
}


// ----------------------------------------------------------------------------------
// Element sichtbar?
// ----------------------------------------------------------------------------------
$.fn.isOnScreen = function()
{
    var win = jQuery(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

// var pagerIndex=-1;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);


// ----------------------------------------------------------------------------------
// Höhe des Fullscreen-Headersdsfdsf
// ----------------------------------------------------------------------------------
function headerImageAdapt() {

    var heightTop=$('#top').height();


    var ratio = $(window).width() / $(window).height();

    console.log(ratio);
    if (ratio>1.3 && ratio < 2) {

        var padding = 20 * 2;
        var slideHeight = $(window).height() - heightTop - padding;
        $('.gallery-headerslider').css('height', slideHeight + 'px').addClass('landscape').removeClass('portrait');
        $('.gallery-headerslider .slide img').css('height', slideHeight + 'px');

        var first=$('.gallery-headerslider .slide img')[0];
        var imageHeight=$(first).height();
        $('.claim-wrapper').css('opacity','1');

    }
    else{
        $('.gallery-headerslider').attr('style','').addClass('portrait').removeClass('landscape');
        $('.gallery-headerslider .slide img').attr('style','');
    }


}

function checkHeightForMenu() {
    var w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    var h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;


    // var txt = "";
    // txt += "<p>innerWidth: " + window.innerWidth + "</p>";
    // txt += "<p>innerHeight: " + window.innerHeight + "</p>";
    // txt += "<p>outerWidth: " + window.outerWidth + "</p>";
    // txt += "<p>outerHeight: " + window.outerHeight + "</p>";

    // console.log(txt);
    (h <= 768) ? $('body').addClass('absMenu') : $('body').removeClass('absMenu');
}


// ----------------------------------------------------------------------------------
// Fenstergröße wurde verändert
// ----------------------------------------------------------------------------------

$( window ).resize(function() {
    fixGallery();
    headerImageAdapt();
    checkHeightForMenu();
    $('body').removeClass('xs sm md lg xl').addClass(bootstrapSize());

});
      
/* Sample function that returns boolean in case the browser is Internet Explorer*/
function isIE() {
    ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    var is_ie = ua.indexOf("MSIE \") > -1 || ua.indexOf(\"Trident/") > -1;
    return is_ie;
}

   

var splashScreenActive=false;

// ----------------------------------------------------------------------------------
// DOM geladen
// ----------------------------------------------------------------------------------


function pingSidebar() {


    if (!$(this).find('body#homepage').length>0) {
        setTimeout(function () {
            $('#sidebar').addClass('animated');
            console.log('ES PINGT');
            pingSidebar();
        }, 5000)
    }


}


function sideBarInit() {

    console.log('los geffhts3335cc33');


    var count=$('.kma-widgets-data li').length;


    var min = 0;
    var max = (count-1);
    var index = Math.round(Math.random() * (max - min)) + min;



    var object=$('.kma-widgets-data li').eq(index);

    var title=object.data('title');
    var subtitle=object.data('subtitle');
    var link=object.data('link');
    var linktitle=object.data('linktitle');
    var image=object.data('image');


    var widget=$('.teaser-box.widget-sidebar');

    widget.find('.title').text(title);
    widget.find('.subtitle').text(subtitle);
    widget.find('.more').attr('href',link);
    widget.find('.more').text(linktitle);
    widget.find('.icon').css('background-image','url('+image+')');


    $('#sidebar .icon').click(function() {
        $('#sidebar').toggleClass('open');
    })

    $(document).on('mouseover', '#sidebar .icon' ,function(){
        //$(this).addClass("animated");
        $('#sidebar').addClass("animated");
    });

    $('#sidebar').bind("webkitAnimationEnd mozAnimationEnd animationEnd", function() {
        $(this).removeClass("animated");
    });

    $('#sidebar .more').click(function(e) {
        //e.preventDefault();

        //var hash=$(this).data('hash');
        $('#sidebar').removeClass("open");
        scrollToTarget($(hash));
    })


    pingSidebar();


}




$(document).ready(function() {

    setTimeout(function() {

        videoplayer = $('.video-embed-fullscreen video').get(0);
        if (videoplayer.muted) {
            $('.video-embed-fullscreen .sound .info').addClass('show');
        }

    },6000)

    setTimeout(function() {
        $('.video-embed-fullscreen .sound .info').removeClass('show');
    },12000)






    $('.video-embed-fullscreen .sound').click(function() {
        video = $(this).parent().find('video');

        sound=$(this).parent().find('.sound');

        videoplayer=video.get(0);

        if (videoplayer.muted) {
            sound.removeClass('muted');
            videoplayer.muted = false;
            $('.video-embed-fullscreen .sound .info').removeClass('show');
        }
        else
        {
            sound.addClass('muted');
            videoplayer.muted = true;
        }


    })


    $('.video-embed-fullscreen video').click(function() {
        videoplayer = $(this).get(0);
        if (videoplayer.paused) {
            videoplayer.play();
            $(this).parent().removeClass('stopped');
        }
        else {
            videoplayer.pause();
            $(this).parent().addClass('stopped');
        }
    });






    sideBarInit();



    $(document).keypress(function(event){
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
            $('.color-filter').toggleClass('active')
        }
    });









    if (isIE()) // If Internet Explorer, return version number
    {
        $('.gallery-headerslider .slide').each(function() {
           var first=$(this).find('picture source').eq(0).attr('srcset');
           var urls=first.split(' 1x');
            $(this).css('background-image','url('+urls[0]+')');
            $(this).find('picture').css('opacity',0);

        });
    }


    $('body').removeClass('xs sm md lg xl').addClass(bootstrapSize());


    // ----------------------------------------------------------------------------------
    // Überschrift wird geklont !
    // ----------------------------------------------------------------------------------

    if ($('.h1-clone').length) {
        $('.h1-clone').html($('h1').html());

    }


    $('.splashscreen .sound').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        video = $('.splashscreen video')[0];



        if (video.muted) {
            $(this).find('i').removeClass('fa-volume-off').addClass('fa-volume-up');
            video.muted = false;
        }
        else {
            video.muted = true;
            $(this).find('i').removeClass('fa-volume-up').addClass('fa-volume-off');
        }
    })



    // ----------------------------------------------------------------------------------
    // Splashscreen
    // ----------------------------------------------------------------------------------

    if ($('.splashscreen video').length>0 && bootstrapSize()!='xs') {

        $('.splashscreen').show();

        $('body').css('overflow','hidden');
        $('.splashscreen video').hide();


        var killSplash= setTimeout(function() {
            splashScreenActive=true;
            video = $('.splashscreen video')[0];
            $(video).find('source').attr('src','/fileadmin/user_upload/videos/splashscreen/neuer-stern-keller-mitausblick.mp4');
            $('.splashscreen video').get(0).load();

            playSplashVideo();
        },5000);


        var req = new XMLHttpRequest();
        req.open('GET', '/fileadmin/user_upload/videos/splashscreen/neuer-stern-keller-mitausblick.mp4', true);
        req.responseType = 'blob';

        req.onload = function() {
            // Onload is triggered even on 404
            // so we need to check the status code
            if (this.status === 200 && !splashScreenActive) {
                var videoBlob = this.response;
                var vid = URL.createObjectURL(videoBlob); // IE10+
                // Video is now downloaded
                // and we can set it as source on the video element
                video = $('.splashscreen video')[0];
                video.src = vid;
                clearTimeout(killSplash);
                playSplashVideo();
            }
        }
        req.onerror = function() {
            // Error
            alert('Da ist ein Fehler aufgetreten');
        }

        req.send();


      $('.splashscreen video').on('ended',function(){
          $('.splashscreen').fadeOut('500',function() {
              $('body').css('overflow','auto');

          });
      });

      $('.splashscreen').click(function() {
         v=$('.splashscreen video')[0];
         v.pause();

          $('body').css('overflow','auto');
         $('.splashscreen').fadeOut('500');

      })
    }

    
    // Animierte Sterne für Videobereich
    $('.stars').addClass('animatefast');
    setTimeout(function() {
        $('.stars').addClass('animate');
    },500)



    // Dynamischer Header
    headerImageAdapt();
    fixGallery();
    checkHeightForMenu();


    $('#navigation .close').click(function() {
    $('#navigation').collapse('hide'); 
  })


    $('.link-area').click(function(e) {


        var target=$(this).find('.more a').attr('target');



        var url=$(this).data('url');

        console.log(url);


        if (url !== undefined && url !== null && url!="") {
            console.log(url)
            e.preventDefault();
            if (target == '_blank') {
                window.open(url);
            } else {
                document.location.href = url;
            }
        }

    })










});

//function mirrorImage(ctx, image, x = 0, y = 0, horizontal = false, vertical = false){
function mirrorImage(ctx, image, x , y, horizontal, vertical){
    ctx.save();  // save the current canvas state
    ctx.setTransform(
        horizontal ? -1 : 1, 0, // set the direction of x axis
        0, vertical ? -1 : 1,   // set the direction of y axis
        x + (horizontal ? image.width : 0), // set the x origin
        y + (vertical ? image.height : 0)   // set the y origin
    );
    ctx.drawImage(image,0,0,800,600);
    ctx.restore(); // restore the state as it was when this function was called
}

// function detectWebcam(callback) {
//     var md = navigator.mediaDevices;
//     if (navigator.mediaDevices) {
//         if (!md || !md.enumerateDevices) return callback(false);
//         md.enumerateDevices().then(devices => {
//             callback(devices.some(device => 'videoinput' === device.kind));
//         })
//     }
// }